import * as Config from '../../config';
import Locale from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord, AlertCategories } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";


export class FilterClogged extends AlertLogic {
    static type = AlertType.FilterClogged;
    static category = AlertCategories.WATER_QUIALITY;
    static contentCategories = [ ContentCategories.WATER_QUALITY ];
    static title = Locale.gettext('Check Filter');

    getInfo(timeZone?: string): AlertInfo {
        const alert = this.alert;
        const config = this.allConfigs;

        // Same for all alert types
        let { body, device, alertData, firstReported } = this.getCommons(timeZone);

        // Varying across alert types
        let cardIllustration = 'garden_cleaning';
        let detailIcon = 'filter';
            
        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('Check Your Filter'),
            cardDescription: this.locale.gettext("%1$s filter might need to be cleaned or inspected", body.Name),
            cardIllustration: cardIllustration,
            detailIcon: detailIcon,
            detailDescriptionArr: [
                this.locale.gettext('We have detected that water flow through your "%1$s" filter might be restricted.', body.Name),
                this.locale.gettext("First check for debris in your skimmer or pump baskets.  If those are clear, it may be time to backwash or clean your filter."),
                this.locale.gettext("Your filter should be cleaned regularly to maintain proper equipment performance and keep your pool water clear."), 
                this.locale.gettext("When the filter is clean, water flows through it easily. As it traps dirt and debris, flow becomes restricted and pressure increases."), 
                this.locale.gettext("Once the pressure rises beyond the normal range, it’s time to clean the filter to restore proper flow.")
            ],
            resolveSummary: this.locale.gettext('%1$s flow has been restored', body.Name)
        });
        alertInfo.contentCategories = FilterClogged.contentCategories;
        return alertInfo;
    } 

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord {
        let device = config.Config.Devices.find(dev => dev.DeviceType === "Filter");
        
        return device ? new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type),
            siteId: Math.floor(Math.random() * 100000),
            entityUuid: device?.UUID,
            bodyUuid: config.Config.BodiesOfWater[0]?.UUID,
            type: type,
            data: {
                
            }
        }) : null;
    }
}